<mat-form-field appearance="outline" floatLabel="always" fxFlex="grow" id="PhoneNumber">
  <mat-label [ngClass]="displayLabel()">{{ label }}</mat-label>
  <ngx-mat-intl-tel-input
    [formControl]="formGroup.controls.phoneNumberRaw"
    format="national"
    [preferredCountries]="['us']"
    [required]="required"
    aria-label="phone number"
  >
  </ngx-mat-intl-tel-input>
  <mat-error
    *ngIf="
      formGroup.controls.phoneNumberRaw.hasError('validatePhoneNumber') ||
      formGroup.controls.phoneNumberRaw.hasError('required') ||
      formGroup.controls.phoneNumber.hasError('minlength') ||
      formGroup.controls.phoneNumber.hasError('notEmpty')
    "
    >Please enter a valid phone number</mat-error
  >
</mat-form-field>
<mat-form-field appearance="outline" floatLabel="always" class="phone-extension">
  <mat-label [ngClass]="displayLabel()">Ext</mat-label>
  <input matInput forbidAngleBrackets [formControl]="formGroup.controls.extension" placeholder="Ext" />
</mat-form-field>
